import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';

export function P00062Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('ppSAlarme') === 1) {
    const titles = [
      'P00062.card.state.fonctionnement.title.cold',
      'P00062.card.state.fonctionnement.title.hot',
      'P00062.card.state.fonctionnement.title.auto',
    ];

    const title = titles[getValue('ppPModeFonctionnementTemperature') ?? 0];

    // Service Polytropic - Alarme système
    if (getValue('ppSEtatSysteme') === 0) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00062.parameters.status.service.polytropic.title',
      });
    }

    // Connexion passerelle
    const produitP00062 = masterClass.hasProduct(pool, productClass);
    if (produitP00062 !== 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle: title,
        title: 'P00062.status.passerelle.connexion',
      });
    }
  }

  return res;
}
